import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import syncImg from '../../../../../assets/Sync.svg'
import {
  getCoinsHistory,
  setCoinsHistory
} from '../../../../../redux/actions/CoinsHistoryActions'
import { DcoinsHistoryDay } from './DcoinsHistoryDay'
import { DcoinsHistoryHeader } from './DcoinsHistoryHeader'
import {
  Container,
  Content,
  ContentTitle,
  LoadMore,
  LoadMoreIcon,
  Modal,
  Overlay
} from './DcoinstHistory.styles'

const today = new Date().toLocaleDateString()

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

function getFormattedDate(date) {
  const year = date.getFullYear()
  const month = monthNames[date.getMonth()]
  const day = date.getDate()

  return `${month}, ${day}, ${year}`
}

export const DcoinsHistory = ({ isOpen, handleClose }) => {
  const { history, isLoading, isEverythingLoaded } = useSelector(
    state => state.coinsHistory
  )

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCoinsHistory())

    return () => dispatch(setCoinsHistory([]))
  }, [])

  const days = Object.values(
    history.reduce((acc, item) => {
      const date = new Date(item.createdAt)
      const isToday = date.toLocaleDateString() === today
      const key = isToday ? 'Today' : getFormattedDate(date)

      if (acc[key]) {
        acc[key].items.push(item)
      } else {
        acc[key] = { date: key, items: [item] }
      }

      return acc
    }, [])
  )

  const handleLoadMore = ({
    target: { scrollHeight, scrollTop, offsetHeight }
  }) => {
    if (
      scrollTop < scrollHeight - offsetHeight - 200 ||
      isLoading ||
      isEverythingLoaded
    )
      return
    dispatch(getCoinsHistory())
  }

  return (
    <>
      <Container isOpen={isOpen}>
        <Modal>
          <DcoinsHistoryHeader handleClose={handleClose} />
          <Content onScroll={handleLoadMore}>
            <ContentTitle>History</ContentTitle>
            {days.map(day => (
              <DcoinsHistoryDay key={day.date} {...day} />
            ))}
            {isEverythingLoaded || (
              <LoadMore>
                <LoadMoreIcon>
                  <img src={syncImg} alt="" />
                </LoadMoreIcon>
                Load More
              </LoadMore>
            )}
          </Content>
        </Modal>
      </Container>
      <Overlay isOpen={isOpen} onClick={handleClose} />
    </>
  )
}
